export default __webpack_public_path__ + "static/media/promtion_pro_three.3dfbedd6.svg";